import { render } from "./PublicatiesView.vue?vue&type=template&id=1b214aac"
import script from "./PublicatiesView.vue?vue&type=script&lang=js"
export * from "./PublicatiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__